import styled from "styled-components";

const SlideImage = styled.img`
  width: 100%;
`;

const SlideContainer = styled.div`
    width: 12.5em;
    height: 16.625em;
    margin-top: 1.7em;
    margin-right: 5em;
    margin-left: 4em;
    margin-bottom: 2em;
    border-radius: 1em;
    border-style: solid;
    border-width: 1em;
`
export { SlideImage, SlideContainer };
